export const CACHE_KEY_LIST_COMPANY = 'companies';
export const CACHE_KEY_COMPANY = 'company-one';
export const ROUTE_PATH_COMPANY = '/company/companies';
export const TRANSLATION_PREFIX_COMPANY = 'company';
export const SECURITY_KEY_COMPANY = 'COMPANY';


export const CACHE_KEY_LIST_TCP = 'tcps';
export const ROUTE_PATH_TCP = '/company/tcp';

import {renderLabel} from '@/modules/company/components/OfficeLabel';


export const options = [
  { label: renderLabel('province'), value: 'province' },
  { label: renderLabel('municipality'), value: 'municipality' },
  { label: renderLabel('company.address'), value: 'address' },
  { label: renderLabel('company.partners'), value: 'partners' },
  { label: renderLabel('company.category'), value: 'category' },
  { label: renderLabel('company.categories'), value: 'categories' },
  { label: renderLabel('company.offices'), value: 'offices' },
];

export const COMPANY_AVATAR = 'avatar';
export const COMPANY_SUBJECT_TYPE = 'subjectType';
export const COMPANY_MAIN_ACTIVITY = 'mainActivity';
export const COMPANY_SOCIAL_DENOMINATION = 'socialDenomination';
export const COMPANY_SOCIAL_OBJECT = 'socialObject';
export const COMPANY_CREATED = 'createdAt';
export const COMPANY_PROVINCE = 'province';
export const COMPANY_MUNICIPALITY = 'municipality';
export const COMPANY_ADDRESS = 'address';
export const COMPANY_PARTNERS = 'partners';
export const COMPANY_CATEGORY = 'category';
export const COMPANY_CATEGORIES = 'categories';
export const COMPANY_EXTRA_FILES = 'extraFiles';
export const COMPANY_OFFICES = 'offices';


export const REJECT_PROCEDURE_MODAL_KEY = 'reject_procedure_modal';
